module.exports = __webpack_public_path__ + "img/204-guernsey.a4952881.svg";